import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ModalAlert = (props) => {
    const { open, handleClose, action, text, title, buttonClose,  buttonAccept } = props
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                
                <DialogContent>

                    <DialogContentText id="alert-dialog-description">
                        {text}
                    </DialogContentText>

                </DialogContent>

                <DialogActions>
                
                    <Button onClick={handleClose} className="MuiButtonBase-root MuiButton-root MuiButton-contained bg-danger text-light mt-2">
                        {buttonClose || 'CANCEL'}
                    </Button>
                    
                    <Button onClick={action} className="MuiButtonBase-root MuiButton-root MuiButton-contained bg-success text-light mt-2" autoFocus>
                        {buttonAccept || 'OK'}
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ModalAlert